import { CfMediaQueriesTextAlignProps, TextAlign } from "types/generic/types";

export const convertCfTextAlignProps = (
  cfProp?: CfMediaQueriesTextAlignProps | null,
): TextAlign | undefined => {
  if (!cfProp) return undefined;

  return {
    defaultTextAlign: cfProp.default || undefined,
    smTextAlign: cfProp.sm || undefined,
    mdTextAlign: cfProp.md || undefined,
    lgTextAlign: cfProp.lg || undefined,
    xlTextAlign: cfProp.xl || undefined,
  };
};
